export type EmbeddedNet = {
  level: "transco" | "discom_sub" | "plant" | "circle" | "feeder";
  id: number | string;
  label: string;
};

export type NetTarget = {
  level: "circle" | "transco" | "discom_sub";
  // Integer primary key for the new JVVNL API (level + ids). Defaults to circle
  // id 1 (KOTPUTLI) when no entity is selected.
  ids: number | string | undefined;
};

export function resolveNetTarget(
  netDiscom: { value: number } | null,
  netTransco: { value: number } | null,
  netCircle: { value: string } | null,
  // Circle id resolved from netCircle's name (the new API takes ids, not name).
  circleId?: number,
): NetTarget {
  if (netDiscom) return { level: "discom_sub", ids: netDiscom.value };
  if (netTransco) return { level: "transco", ids: netTransco.value };
  return { level: "circle", ids: circleId ?? 1 };
}

export function resolveEmbeddedFeederId(embedded?: EmbeddedNet): number | null {
  if (embedded?.level !== "feeder") return null;
  const n = Number(embedded.id);
  return Number.isNaN(n) ? null : n;
}

export type NetVariable = "Demand" | "Generation" | "Net Load";

export type DateRange = { startDate: Date; endDate: Date; key?: string };

export type FeederChartMode =
  | { kind: "standalone" }
  | {
      kind: "popup";
      embedded: EmbeddedNet;
      weatherParam?: string | null;
      netVariable?: NetVariable | "Actual" | "Forecast" | "Weather" | null;
      variablesOverride?: string[] | null;
      forecastVariants?: string[] | null;
      actualVariants?: string[] | null;
      dateRangeOverride?: DateRange | null;
      forecastDateOverride?: string | null;
      emptyStateHeight?: string | number;
      tooltipBoundary?: "viewport" | "chart";
      onEmbeddedFeederChange?: (f: { id: number; name: string } | null) => void;
      onEmbeddedFeederListChange?: (fs: { id: number; name: string }[]) => void;
      onEmbeddedNetChange?: (
        t: {
          level: "discom_sub" | "transco" | "circle";
          id: number | string | undefined;
          name: string;
        } | null,
      ) => void;
    };
